import { Action } from "../../../actions/actions";
import { call, put, takeLatest } from "@redux-saga/core/effects";
import { authAPI } from "../api/auth.api";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { authMessagesStrings } from "../assets/authMessages.strings";
import { AuthActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* getRoles(action: Action) {
    try {
        const data = yield call(authAPI.getRoles, action.payload);
        yield put({
            type: AuthActionTypes.GET_ROLES_LIST_SUCCESS,
            payload: data.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting roles list.");

        yield put({
            type: AuthActionTypes.GET_ROLES_LIST_FAIL,
            message: e.message
        });
    }
}

export function* getRolesWatcher() {
    yield takeLatest(AuthActionTypes.GET_ROLES_LIST, getRoles);
}

function* createRole(action: Action) {
    try {
        const { role_info, current_page, total_roles_by_page } = action.payload;
        const createRequest = yield call(authAPI.createRole, role_info);

        if (createRequest.status == 207) {
            const subsidiariesDescription = createRequest.data.unsaved.map(
                sub => sub.description
            );

            const msg =
                createRequest.data.unsaved.length > 1
                    ? `Partial Success. ${createRequest.data.unsaved.length} failed creation. Validate if names for subsidiaries (${subsidiariesDescription}) already exist.`
                    : `Partial Success. ${createRequest.data.unsaved.length} failed creation. Validate if name for subsidiary (${subsidiariesDescription}) already exist.`;
            ToasterService.infoToast(msg);
        } else {
            ToasterService.successToast(
                authMessagesStrings.CREATE_ROLE_SUCCESS
            );
        }

        yield put({
            type: AuthActionTypes.CREATE_ROLE_SUCCESS
        });

        yield put({
            type: AuthActionTypes.GET_ROLES_LIST,
            payload: {
                current_page: current_page,
                total_roles_by_page: total_roles_by_page
            }
        });
    } catch (e) {
        if (e.response.status === 500 && e.response.data.code === 9035) {
            if (
                Array.isArray(action.payload.role_info.subidiary) &&
                action.payload.role_info.subidiary.length > 1
            ) {
                ToasterService.errorToast(
                    "One of the roles as the same name of a existing one in the same subsidiary."
                );
            } else {
                ToasterService.errorToast(
                    "A role with the same name already exists in this subsidiary."
                );
            }
        } else {
            API.handleError(e.response, "Error creating role.");
        }
        yield put({
            type: AuthActionTypes.CREATE_ROLE_FAIL,
            error: e.message
        });
    }
}

export function* createRoleWatcher() {
    yield takeLatest(AuthActionTypes.CREATE_ROLE, createRole);
}

function* deleteRole(action: Action) {
    try {
        const { role_id, current_page, total_roles_by_page } = action.payload;
        yield call(authAPI.deleteRole, role_id);
        ToasterService.successToast(authMessagesStrings.DELETE_ROLE_SUCCESS);

        yield put({
            type: AuthActionTypes.GET_ROLES_LIST,
            payload: {
                current_page: current_page,
                total_roles_by_page: total_roles_by_page
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error deleting role.");
        yield put({
            type: AuthActionTypes.DELETE_ROLE_FAIL,
            error: e.message
        });
    }
}

export function* deleteRoleWatcher() {
    yield takeLatest(AuthActionTypes.DELETE_ROLE, deleteRole);
}

function* editRole(action: Action) {
    try {
        const { role_id, role_info, current_page, total_roles_by_page } =
            action.payload;

        yield call(authAPI.editRole, {
            role_id,
            role_info
        });

        ToasterService.successToast(authMessagesStrings.EDIT_ROLE_SUCCESS);

        yield put({
            type: AuthActionTypes.EDIT_ROLE_SUCCESS
        });

        yield put({
            type: AuthActionTypes.GET_ROLES_LIST,
            payload: {
                current_page: current_page,
                total_roles_by_page: total_roles_by_page
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error editing role.");
        yield put({
            type: AuthActionTypes.EDIT_ROLE_FAIL,
            error: e.message
        });
    }
}

export function* editRoleWatcher() {
    yield takeLatest(AuthActionTypes.EDIT_ROLE, editRole);
}

function* getResourceEntity(action: Action){
    try {
        const data = yield call(authAPI.getResourceEntity)
        yield put({
            type: AuthActionTypes.GET_RESOURCE_ENTITY_SUCCESS,
            payload: data.data
        });
    }
    catch (e) {
        API.handleError(e.response, "Error getting resource entity list.");

        yield put({
            type: AuthActionTypes.GET_RESOURCE_ENTITY_FAIL,
            message: e.message
        });
    }
}

export function* getResourceEntityWatcher() {
    yield takeLatest(AuthActionTypes.GET_RESOURCE_ENTITY, getResourceEntity);
}